// extracted by mini-css-extract-plugin
export var contentContainer = "product-description-module--contentContainer--748c9";
export var ctaLink = "product-description-module--ctaLink--9da54";
export var descriptionContainer = "product-description-module--descriptionContainer--36a5d";
export var gradientOverlay = "product-description-module--gradientOverlay--6260b";
export var image = "product-description-module--image--7a261";
export var imageContainer = "product-description-module--imageContainer--5be7a";
export var innerContent = "product-description-module--innerContent--840f4";
export var productName = "product-description-module--productName--a5803";
export var readMoreButton = "product-description-module--readMoreButton--2ff62";
export var typeform = "product-description-module--typeform--98e61";
export var wrapper = "product-description-module--wrapper--2a8ff";